/**
 * Configurator: Vorhangstange nach Mass (Curtain Rods)
 *
 * Sections:
 *   1. Helpers
 *   2. Config       — read data attributes set by configurator-stange.liquid
 *   3. Holder count — auto-calculate bracket count from length
 *   4. Price        — calculate and display live price (3 components)
 *   5. Validate     — enforce min 80 / max 450, show inline error
 *   6. Display      — update holder count display on input change
 *   7. Cart         — intercept add-to-cart, call duplicate_stange.cfm, then /cart/add.js
 */

$(document).ready(function () {

  // ─────────────────────────────────────────────
  // 1. Helpers
  // ─────────────────────────────────────────────

  function formatPrice(amount) {
    // Swiss format: "CHF 1'234.50"
    return 'CHF ' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function roundOneDecimal(num) {
    return Math.round(num * 10) / 10;
  }

  // ─────────────────────────────────────────────
  // 2. Config
  // ─────────────────────────────────────────────

  var $container = $('[data-stange-configurator]');

  // Bail out if no stange configurator on this page
  if ($container.length === 0) return;

  var pricePerHundred  = parseFloat($container.data('price-per-100cm'));
  var holderPrice      = parseFloat($container.data('holder-price'));
  var railEndingPrice  = parseFloat($container.data('rail-ending-price'));
  var minLength        = parseInt($container.data('min-length'), 10);
  var maxLength        = parseInt($container.data('max-length'), 10);

  var $lengthInput     = $('#stange-laenge');
  var $aufhaengeort    = $('#stange-aufhaengeort');
  var $lengthError     = $('[data-stange-length-error]');
  var $holderDisplay   = $('[data-stange-holder-count]');

  var $addToCart       = $('[data-add-to-cart-trigger]');

  // ─────────────────────────────────────────────
  // 3. Holder count
  // ─────────────────────────────────────────────

  function calcHolderCount(lengthCm) {
    if (lengthCm <= 160) return 2;
    if (lengthCm <= 260) return 3;
    if (lengthCm <= 360) return 4;
    return 5;
  }

  // ─────────────────────────────────────────────
  // 4. Price
  // ─────────────────────────────────────────────

  function calcPrice(lengthCm) {
    var holders        = calcHolderCount(lengthCm);
    var rodCost        = (lengthCm / 100) * pricePerHundred;
    var holderCost     = holders * holderPrice;
    var railEndingCost = 2 * railEndingPrice;
    return Math.round((rodCost + holderCost + railEndingCost) * 100) / 100;
  }

  function updatePriceDisplay(lengthCm) {
    var price = calcPrice(lengthCm);
    $('.purchase-details .price .money')
      .text(formatPrice(price))
      .attr('data-price', price);
  }

  function clearPriceDisplay() {
    $('.purchase-details .price .money')
      .text('–')
      .removeAttr('data-price');
  }

  // ─────────────────────────────────────────────
  // 5. Validate
  // ─────────────────────────────────────────────

  function showError(msg) {
    $lengthError.text(msg).show();
    $addToCart.prop('disabled', true);
  }

  function clearError() {
    $lengthError.text('').hide();
    $addToCart.prop('disabled', false);
  }

  function validateLength(lengthCm) {
    if (isNaN(lengthCm) || lengthCm === '') {
      clearPriceDisplay();
      $holderDisplay.text('–');
      $addToCart.prop('disabled', true);
      return false;
    }
    if (lengthCm < minLength) {
      showError('Mindestlänge: ' + minLength + ' cm');
      clearPriceDisplay();
      $holderDisplay.text('–');
      return false;
    }
    if (lengthCm > maxLength) {
      showError('Maximallänge: ' + maxLength + ' cm');
      clearPriceDisplay();
      $holderDisplay.text('–');
      return false;
    }
    clearError();
    return true;
  }

  // ─────────────────────────────────────────────
  // 6. Display — update on input change
  // ─────────────────────────────────────────────

  // Button must be disabled on load — no length entered yet
  $addToCart.prop('disabled', true);

  $lengthInput.on('input change', function () {
    var raw = parseFloat($(this).val());
    var lengthCm = isNaN(raw) ? raw : roundOneDecimal(raw);
    if (validateLength(lengthCm)) {
      $holderDisplay.text(calcHolderCount(lengthCm) + ' Stück');
      updatePriceDisplay(lengthCm);
    }
  });

  $lengthInput.on('blur', function () {
    var raw = parseFloat($(this).val());
    if (!isNaN(raw)) {
      $(this).val(roundOneDecimal(raw));
    }
  });

  // ─────────────────────────────────────────────
  // 7. Cart
  // ─────────────────────────────────────────────

  $addToCart.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($addToCart.hasClass('disabled')) return;

    var raw = parseFloat($lengthInput.val());
    var lengthCm = isNaN(raw) ? raw : roundOneDecimal(raw);
    if (!validateLength(lengthCm)) return;

    var holderCount = calcHolderCount(lengthCm);

    // Build the payload for duplicate_stange.cfm
    var productData = {
      pid:                  $('[data-product-id]').data('product-id'),
      productType:          'stange',
      price:                calcPrice(lengthCm),
      title:                $('.vs-product-title').text().trim(),
      StangeLange:          lengthCm,
      AnzahlTraeger:        holderCount,
      original_product_url: window.location.href
    };

    var aufhaengeort = $.trim($aufhaengeort.val());
    if (aufhaengeort !== '') {
      productData.Aufhaengeort = aufhaengeort;
    }

    // Disable buttons while loading
    $addToCart.addClass('disabled button_loading');
    $('.fabric-sample > button').addClass('disabled');

    var shopDomain = window.PXUTheme.theme_settings.domain;

    $.ajax({
      type:        'POST',
      url:         'https://apps.vorhingschweiz.com/functions/duplicate_stange.cfm',
      data:        JSON.stringify(productData),
      contentType: 'application/json',
      dataType:    'json',
      headers:     { 'x-shopify-shop': shopDomain },

      success: function (data) {
        if (data.success !== true) {
          console.error('duplicate_stange.cfm error', data);
          $addToCart.removeClass('disabled button_loading');
          return;
        }

        // Build Shopify line item properties (visible in order)
        var cartProperties = {
          'Stangenlänge':          lengthCm + ' cm',
          'Anzahl Träger':         holderCount + ' Stück',
          'Abschlüsse':            '2 Stück, Im Preis inbegriffen',
          '_original_product_url': productData.original_product_url
        };

        if (aufhaengeort !== '') {
          cartProperties['Aufhängeort'] = aufhaengeort;
        }

        // Read delivery time from page
        var lieferzeitEl = $('[data-lieferzeit]');
        if (lieferzeitEl.length) {
          var lieferzeitVal = lieferzeitEl.text().trim();
          if (lieferzeitVal) {
            cartProperties['_Lieferzeit'] = lieferzeitVal;
          }
        }

        $.ajax({
          type:     'POST',
          url:      '/cart/add.js',
          dataType: 'json',
          data: {
            items: [{
              id:         data.vid,
              quantity:   parseInt($('.quantityPrice input.quantity-input.quantity-element').val()) || 1,
              properties: cartProperties
            }]
          },

          success: function () {
            $addToCart.removeClass('button_loading');
            $addToCart.find('svg.checkmark').addClass('checkmark-active');
            window.PXUTheme.jsAjaxCart.updateView();

            setTimeout(function () {
              $addToCart.find('i, span').hide();
            }, 300);

            setTimeout(function () {
              $('.header-cart.action-area__link').addClass('show-mini-cart');
              $addToCart.removeClass('disabled');
              $('.fabric-sample > button').removeClass('disabled');
              $addToCart.find('i, span').removeClass('zoomOut').show();
              $addToCart.find('svg.checkmark').removeClass('checkmark-active');
            }, 2000);
          },

          error: function (xhr) {
            console.error('/cart/add.js error', xhr);
            $addToCart.removeClass('disabled button_loading');
            $('.fabric-sample > button').removeClass('disabled');
          }
        });
      },

      error: function (xhr) {
        console.error('duplicate_stange.cfm request failed', xhr);
        $addToCart.removeClass('disabled button_loading');
        $('.fabric-sample > button').removeClass('disabled');
      }
    });
  });

});
